export const UNIMPORT_WIDGET_ID = "UNIMPORT_WIDGET_ID";
export const RESET_WIDGET_IDS = "RESET_WIDGET_IDS";
export const REMOVE_WIDGET_ID = "REMOVE_WIDGET_ID";

interface UpdatedUnimportWidget {
    type: typeof UNIMPORT_WIDGET_ID;
    data: string;
}
interface ResetWidgetIDs {
    type: typeof RESET_WIDGET_IDS;
}

interface RemoveWidgetID {
    type: typeof REMOVE_WIDGET_ID,
    data: string
}

export type UpdatedWidgetID = UpdatedUnimportWidget | ResetWidgetIDs | RemoveWidgetID ; 